<template>
  <div class="i-container">
    <div class="i-header d-flex align-items-center justify-content-between px-3">
      <div class="fw-bold text-white">“明石杯”微纳传感技术与智能应用大赛后台管理系统</div>
<!--      <div class="text-white small" v-if="role==='students'">报名截止时间：{{register_end}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作品提交截止时间：{{upload_end}}</div>-->
      <div class="text-white small" v-if="role==='students'">
        <text v-if="enterFinal">恭喜您，您的队伍已进入复赛</text>
        <text v-else>作品提交截止时间：{{upload_end}}</text>
      </div>
      <div class="d-flex align-items-center">
        <a class="point-curser text-white text-decoration-none me-2 small">消息</a>
        <div class="header-icon rounded-circle mx-3">
          <img  :src="defultAvater" alt="">
        </div>
        <a class="point-curser text-white text-decoration-none small">{{userInfo.Contact||userInfo.username || "未知"}}</a>
        <text class="mx-2 text-white">|</text>
        <a class="point-curser text-white text-decoration-none small" @click="loginOut">退出</a>
      </div>
    </div>
    <div class="i-content d-flex">
      <div class="c-left">
        <MenuListCom></MenuListCom>
      </div>
      <div class="c-right">
        <router-view v-slot="{ Component }" >
          <component :is="Component" :key="$route.path"/>
        </router-view>
      </div>
    </div>
  </div>

</template>

<script setup>
import {useStore} from 'vuex'
const store = useStore()
import MenuListCom from "@/baseLayout/MenuListCom"
import {computed,ref,onMounted} from "vue"
import {ElMessage,ElMessageBox} from "element-plus"; // 引入useStore 方法
const defultAvater = require("@/assets/images/defultAvater.png")
const userInfo = computed(()=>store.state.loginModel.userInfo) || {}
const register_end = computed(()=>store.state.sysModel.register_end) // 注册结束时间
const upload_end = computed(()=>store.state.sysModel.upload_end) // 作品截止提交时间
const enterFinal = ref(false) // 是否进入决赛
const role = ref() // 角色
// const title = computed(()=>store.state.sysModel.title)
onMounted(async ()=>{
  // store.dispatch("sysModel/getAllsettingsFun") // 获取系统配置
  role.value = store.getters['loginModel/getRole']
  if(role.value==="students"){
    // store.dispatch("sysModel/getAllsettingsFun") // 获取系统配置
    await store.dispatch("loginModel/getUserInfo") //获取用户信息
    const u = store.getters["loginModel/getUserInfo"] || {}
    enterFinal.value = u.enterFinal
  }

})

const loginOut = ()=>{
  ElMessageBox.alert('确定要退出吗？', '退出', {
    confirmButtonText: '确定',
    callback: (action) => {
      if(action==='confirm'){ // 确定
        store.dispatch('loginModel/loginOut').then(() => {
          ElMessage.success('登出成功')
        })
      }
    },
  })
}

</script>

<style scoped lang="scss">
$header: 60px;
$boderC:#dcdfe6;
$headericonsize:25px;
.i-container {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .i-header {
    height: $header;
    width: 100%;
    background: #536fc4;
  }
  .header-icon{
    height: $headericonsize;
    width: $headericonsize;
    display: inline-block;
    overflow: clip;
    >img{
      width:90%;
      height: 90%;
      object-fit: cover;
    }

  }

  .i-content {
    overflow: hidden;
    height: calc(100vh - $header);
    background: #e4e5e4;

    .c-left {
      &::-webkit-scrollbar{
        display: none;
      }
      width: 220px;
      background: #47517a;
      flex: 0 0 auto;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      border-right: 1px solid $boderC;
    }
    .c-right {
      flex: 1;
      background: #faf7f7;
    }
  }
}
</style>
